<template>
  <component
    :is="href ? 'a' : 'button'"
    v-bind="href ? { 'href': href } : ''"
    ref="btn"
    @click="cancelAutoScroll && $refs.btn.blur()"
    class="vue-button"
    :disabled="isNativeDisabled"
    :target="computedTarget"
    :class="[
      type ? 'vue-button--' + type : '',
      size ? 'vue-button--' + size : '',
      additionalType ? 'vue-button--' + additionalType : '',
      {'vue-button--disabled': isDisabled},
      {'vue-button--full': fullWidth},
      {'vue-button--without-border': withoutBorder}
    ]"
    :type="nativeType">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'Button',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    },
    isDisabled: Boolean,
    isNativeDisabled: Boolean,
    secondary: Boolean,
    type: String,
    additionalType: String,
    size: String,
    cancelAutoScroll: Boolean,
    fullWidth: Boolean,
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    },
    withoutBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedTarget () {
      if (this.href) {
        return this.target
      }
      return false
    }
  }
}
</script>

<style lang="sass" scoped>

// TODO: поменять название класса

.vue-button
  position: relative
  border-radius: 3px
  font-size: 15px
  color: #fff
  display: block
  font-weight: 500
  background-color: $main-color
  border: 1px solid $main-color
  transition: .1s
  padding: 11px 30px

  &:not(&--disabled):not(&--plain):not(&--plain-transparent):not(&--pseudo-link):not(&--transparent):not(&--gray):hover:not(&--white-text):not(&--danger):hover:not(&--dark):hover
    background-color: $main-color--hover
    border-color: $main-color--hover

  &--gray
    color: $text-color
    background-color: #F8F8F8
    border: 1px solid #f8f8f8

    &:hover
      background-color: transparent

  &--white-text

    &:hover
      background-color: transparent
      color: $white-text-color

  &--plain
    background-color: white
    color: $main-color-black

    &:hover
      background-color: $main-color
      color: white

  &--plain-transparent
    background-color: transparent
    color: $main-color-black

    &:hover
      background-color: $main-color
      color: white

  &--dark
    background-color: $text-color
    color: $white-text-color
    border: 1px solid $text-color

    &:hover
      background-color: transparent
      color: $text-color

  &--danger
    background-color: transparent
    color: #eb3434
    border: 2px solid #eb3434

    &:hover
      background-color: transparent
      color: #eb3434

  &--disabled
    color: $text-color
    background-color: #E7E7E7
    border: 0

    &:hover
      color: $text-color
      background-color: #E7E7E7

  &--xs
    font-size: 14px
    padding: 13px 30px

  &--small
    padding: 5px 40px

  &--medium
    font-size: 16px
    font-weight: 400
    padding: 15px 50px

  &--big
    font-size: 16px
    font-weight: 400
    padding: 20px 40px

  &--transparent
    background-color: transparent
    color: $white-text-color
    border: 1px solid $white-text-color

  &--full
    width: 100%

  &--max-content
    width: max-content

  &--pseudo-link
    color: #3e77aa
    font-size: 14px
    font-weight: 500
    background: transparent
    border-color: transparent
    padding: 0
    border-bottom: 1px solid #3e77aa
    cursor: pointer
    display: inline-block

    &:hover
      border-color: transparent

  &--without-border
    border: none

</style>
